// ./js/common/accordion.js
export function initCareerAccordion() {
  document.querySelectorAll(".js-toggle").forEach((btn) => {
    const panel = getPanel(btn);
    if (!panel) return;

    // 初期化（閉）
    btn.setAttribute("aria-expanded", "false");
    panel.style.height = "0px";
    panel.style.overflow = "hidden";

    btn.addEventListener("click", () => {
      const open = btn.getAttribute("aria-expanded") === "true";

      if (open) {
        // close: auto(または数値) → 数値 → 0
        panel.style.height = panel.scrollHeight + "px";
        requestAnimationFrame(() => (panel.style.height = "0px"));
        btn.setAttribute("aria-expanded", "false");
        panel.classList.remove("is-open");
      } else {
        // open: 0 → 内容高 → auto
        const h = panel.scrollHeight;
        panel.style.height = h + "px";
        const onEnd = (e) => {
          if (e.target !== panel) return;
          panel.style.height = "auto";
          panel.removeEventListener("transitionend", onEnd);
        };
        panel.addEventListener("transitionend", onEnd);
        btn.setAttribute("aria-expanded", "true");
        panel.classList.add("is-open");
      }
    });
  });

  function getPanel(btn) {
    // 1) data-targetでセレクタ指定, 2) aria-controlsでID指定, 3) 直後の兄弟が .js-accordion
    const sel = btn.getAttribute("data-target");
    if (sel) return document.querySelector(sel);
    const id = btn.getAttribute("aria-controls");
    if (id) return document.getElementById(id);
    const next = btn.nextElementSibling;
    return next && next.classList?.contains("js-accordion") ? next : null;
  }
}
